<template>
  <div class="d-flex flex-end">
    <iframe
      src="https://www.playtron.bet/betConsole/console/rocky/live.html"
      style="width: 490px; height: 370px; padding-top: 4px"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LiveFieldWidget',
  data: () => ({}),
  beforeDestroy() {},
  computed: {
    ...mapGetters({
      getSettings: 'cart/getSettings',
      getLoading: 'cart/getLoading',
    }),
  },
  methods: {
    ...mapActions({}),
  },
}
</script>

<style scoped></style>
